import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-introduction.jpg'

const paperInfo = {
  paperName: '３分で分かるcommmune資料',
  thumbnail,
  feature1: '実際に使用できる具体的な機能',
  feature2: '導入することで得られる効果',
  feature3: 'commmuneの実績',
  description:
    '企業とユーザーが融け合うコミュニティサクセスプラットフォームcommmuneが選ばれる理由とは。具体的な機能やプラン体系、導入実績など、commmuneについての理解が深まる資料です。',
  formSrc: 'https://go.commmune.jp/l/915341/2021-03-05/f9y',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
